module.exports = __webpack_public_path__ + "static/media/imac-placeholder.2ec3e0eb.png";